import { useMemo } from 'react';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters';
import { AvailableProductsResponse } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export type UserSegJiraTemplateRedesign = {
	userSegmentationEnrollmentPreconditionsMet: boolean;
};

/**
 * useUserSegJiraTemplateRedesign
 *
 * Hook that determines to enroll a user into ATLAS_58859
 * @returns object
 */
export function useUserSegJiraTemplateRedesign(
	availableProducts: AvailableProductsResponse | null,
): UserSegJiraTemplateRedesign {
	const { products, templateId } = useSearchParameters();
	const sites = availableProducts?.sites;
	const userSegmentationEnrollmentPreconditionsMet = useMemo(() => {
		let newJiraUser = false;
		try {
			const isProvisioningOnlyJSW =
				products.length === 1 && products[0] === 'jira-software.ondemand';

			if (isProvisioningOnlyJSW && products.length === 1) {
				// TODO: Move logic to allow existing non jira customers to view this screen to the jira screen configuration
				const jiraSites =
					sites?.filter((site) => site.products.includes('jira-software.ondemand')) ?? [];

				newJiraUser = jiraSites.length === 0;
			}
		} catch (error) {
			console.log(error);
		}

		const hasTemplateRecommendation = Boolean(templateId);
		const isProvisioningOnlyJSW = products.length === 1 && products[0] === 'jira-software.ondemand';
		return !hasTemplateRecommendation && isProvisioningOnlyJSW && newJiraUser;
	}, [templateId, products, sites]);

	return {
		userSegmentationEnrollmentPreconditionsMet,
	};
}
